import { render, staticRenderFns } from "./BuyOffer.vue?vue&type=template&id=8ae4aace&scoped=true&"
import script from "./BuyOffer.vue?vue&type=script&lang=js&"
export * from "./BuyOffer.vue?vue&type=script&lang=js&"
import style0 from "./BuyOffer.vue?vue&type=style&index=0&id=8ae4aace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae4aace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
